import Dexie, { Table } from 'dexie';

// Интерфейс для наших данных сессии
export interface ISessionData {
    key: string; // 'sourcePhrases' или 'uniqueWords'
    value: any;  // Здесь будет либо строка, либо массив строк
}

export class KeywordsToolDB extends Dexie {
    sessionData!: Table<ISessionData>; 

    constructor() {
        super('KeywordsToolDB');
        // Описываем схему для версии 2
        this.version(2).stores({
            // Таблица для данных сессии, где 'key' - это первичный ключ
            sessionData: 'key' 
        });
    }
}

export const db = new KeywordsToolDB();